import {
    apiRequest,
    daftarpegawai,
    PromotionPegawaiCreate,
    daftarpangkat,
    PromotionPegawaiDetail,
    PromotionPegawaiApprove
} from "../../../../../services/adapters/kepegawaian/kenaikanpangkatService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", PromotionPegawaiApprove, {
            body: query
        }, true)
    }
    fetchEmployee = async (query) => {
        return await apiRequest("get", daftarpegawai, {
            params: query
        }, true)
    }
    fetchRank = async (query) => {
        return await apiRequest("get", daftarpangkat, {
            params: query
        }, true)
    }
    fetchDetail = async (query) => {
        return await apiRequest("get", PromotionPegawaiDetail, {
            params: query
        }, true)
    }
}

export default CreateRepository